/**
 * Se definen las constantes que se usaran para construir el endpoint de la llamada
 */

export const DICTIONARY_CONFIG = {
  serviceName: 'https://ws.walmeric.com/provision/wsVars/getVar.html?',
  idTag:
    'idTag=29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953a5615598f335ef3617b59778e6434681b1a930da082e80759d55a6dbbcee1aa43f91b1b642e8d015e224d1f40b4e72c16d3854fd419c16c508040d69278c688f2a1f948e6ad48c4fc9aff30891cb57cc2',
  dictionaryName: '&name=GENERALI_SITEMAP_LOAD_SCRIPTS',
  urlFake: 'https://www.generali.es/seguros-empresa/devolucion-de-anticipos'
}
